module.exports = __webpack_public_path__ + "assets/6sense.fd74a2aa.svg";